import { ICategorySoldProducts } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

export const isExistCategoryKeyInData = (data: ICategorySoldProducts[], categoryKey: string) => {
  if (!data?.length) {
    return false
  }
  const find = data.find((el) => el.Key === categoryKey)
  return Boolean(find)
}
